import { RESOLUTION_META } from "../constants/flow.js";
import { handlePrice } from "../utils/utils.js";
import { bonusLabel } from "../api/resolutions.js";
import styles from "./Summary.module.css";

const reasonLabel = (reason) => {
  const map = {
    COLOR: "Não gostei da cor",
    DEFECTIVE: "Chegou com defeito",
    SIZE_TOO_SMALL: "Ficou pequeno",
    SIZE_TOO_LARGE: "Ficou grande",
    STYLE: "Não gostei do estilo",
    WRONG_ITEM: "Recebi o item errado",
    UNWANTED: "Não quero mais",
    UNKNOW: "Desconhecido",
    OTHER: "Outro motivo",
    NOT_AS_DESCRIBED: "Diferente do anunciado",
  };
  return map[reason] || reason || "—";
};

const Summary = ({ products, resolutionType, settings }) => {
  const meta = RESOLUTION_META[resolutionType] || RESOLUTION_META.refund;
  const option = settings?.[resolutionType] || {};
  const bonus = bonusLabel(option);
  return (
    <section className={styles.box} aria-label="Resumo da solicitação">
      <h3>Resumo</h3>
      <p className={styles.resolution}>
        Resolução: <strong>{meta.label}</strong>
        {bonus ? ` · ${bonus}` : ""}
      </p>
      <ul className={styles.list}>
        {(products || []).map((item) => (
          <li key={item.sku_id || item.sku} className={styles.item}>
            {item.image ? <img src={item.image} alt="" /> : <div className={styles.fallback} aria-hidden="true" />}
            <div>
              <p className={styles.name}>{item.title || item.name}</p>
              {item.variantTitle ? <p className={styles.meta}>{item.variantTitle}</p> : null}
              <p className={styles.meta}>Motivo: {reasonLabel(item.reason)}</p>
              {item.newOrderVariantId ? (
                <p className={styles.meta}>
                  {item.newVariantTitle ? `Trocar por: ${item.newVariantTitle}` : "Troca escolhida"}
                </p>
              ) : null}
              <p className={styles.price}>R$ {handlePrice(item.price)}</p>
              {Number(item.dueAmount) > 0 ? (
                <p className={styles.meta}>Diferença a pagar: R$ {handlePrice(item.dueAmount)}</p>
              ) : null}
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default Summary;
